<template>
	<div>
		<div ref="modalSpinners" 
			class="modal fade" :class="{ show: $store.getters.loading, 'd-block': $store.getters.loading }"
			tabindex="-1" role="dialog">
			<div class="modal-dialog modal-dialog-centered modal-sm" 
				role="document">
				<div class="modal-content  max-w-xs">
					<div class="modal-body">
						<b-container>
							<div class="text-center">
								<div class="row">
									<div class="col-md-12" align="center">
										<img src="@/assets/img/company/Logo-PASTA BELLA -NEW-B_OFF.png" width="90%"/>
									</div>
									<!-- <div class="col-md-12" align="center">
										<p class="align-center">
											<b-spinner label="" type="grow" variant="warning"/> Veuillez patienter ... 
										</p>
									</div> -->
									<div class="col-md-12 pt-2" align="center">
										<p class="align-center">
											Veuillez patienter 
										</p>
										<VueSpinnerDots size="50" color="#ecaf52" style="text-align: center" />
									</div>
									
									<div class="col-md-12" align="center" v-if="$store.getters.loadingMsg && $store.getters.loadingMsg != ''">
										<br>
										<p>
											<small>
												<i>{{$store.getters.loadingMsg}}</i>
											</small>
										</p>
									</div>
								</div>
								
							</div>
							
						</b-container>
					</div>
					
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default { name: "modal-spinners"}
</script>
<style scoped >
	.spinner-img{
		height: 0.8rem;
	}
	.spinner-bg-image-company {
		background-image: url('@/assets/img/company/mapral.ico');
		background-size: center; /*cover*/
		background-position: center center;
		background-repeat: no-repeat;
		height: 80vh; /*150vh*/
		width: auto;
		background-color: white;
		
	}
</style>